import { ActionType } from 'typesafe-actions';

import * as SettingsActions from 'store/actions/settings';
import { call, put, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import GipsyyGDSApi from 'apis/GipsyGDS';
import { SettingsResponse } from 'store/types/settings';

function* putSettings(action: ActionType<typeof SettingsActions.putSettings.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: SettingsResponse } } = yield GipsyyGDSApi.put(
      Endpoints.putSettings(),
      action?.payload,
      {
        headers: {
          Authorization: `bearer ${token}`,
        },
      },
    );
    yield call(resolvePromiseAction, action, response.data.data);
    yield response.data.data;
  } catch (error) {
    console.log('error');
    yield put(SettingsActions.putSettings.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getSettings(action: ActionType<typeof SettingsActions.getSettings.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: SettingsResponse } = yield GipsyyGDSApi.get(Endpoints.getSettings(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(SettingsActions.getSettings.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
    yield response.data;
  } catch (error) {
    console.log('error');
    yield put(SettingsActions.getSettings.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchSettings = [
  takeEvery(SettingsActions.putSettings.request, putSettings),
  takeEvery(SettingsActions.getSettings.request, getSettings),
];
